export default class BoneMap {
  bones = new Map();
  obj = null;

  constructor(obj = null) {
    if (obj) this.from(obj);
  }

  from(obj) {
    this.obj = obj;

    const bAry = obj.bones;
    let bp;
    let bi;
    let key;

    for (const b of bAry) {
      // console.log( 'Bone: ', b.name );
      for (bp of Parsers) {
        // Can generate universal bone key?
        if (!(key = bp.test(b.name))) continue;
        bi = this.bones.get(key);

        // console.log('---', key);

        if (!bi) {
          // Get bone info, else create if doesn't exist
          this.bones.set(key, new BoneInfo(b));
        } else if (bi && bp.isChain) {
          // If found & is a chain, push extra bones
          bi.push(b);
          break;
        }

        if (bp.allowSkip) break;
      }
    }
  }

  getBoneMap(name) {
    return this.bones.get(name);
  }

  getBoneIndex(name) {
    const bi = this.bones.get(name);
    return bi ? bi.items[0].index : -1;
  }

  getBones(aryNames) {
    const bAry = this.obj.bones;
    const rtn = [];

    let bi;
    let i;
    for (const name of aryNames) {
      bi = this.bones.get(name);
      if (bi) {
        for (i of bi.items) rtn.push(bAry[i.index]);
      } else {
        console.warn('Bonemap.getBones - Bone not found', name);
      }
    }

    return rtn.length >= aryNames.length ? rtn : null;
  }

  getBoneNames(ary) {
    const rtn = [];
    let bi;
    let i;

    for (const name of ary) {
      if ((bi = this.bones.get(name))) {
        for (i of bi.items) rtn.push(i.name);
      } else {
        console.warn('Bonemap.getBoneNames - Bone not found', name);
        return null;
      }
    }

    return rtn;
  }

  getChestBone() {
    const bAry = this.obj.bones;
    const rtn = [];

    const bi = this.bones.get('spine');
    if (bi) {
      rtn.push(bAry[bi.lastIndex]);
    }

    return rtn.length > 0 ? rtn : null;
  }

  getBoneSet(n) {
    const bs = BONE_SETS[n];
    const ary = [];

    let bi;
    for (let i of bs) {
      bi = this.bones.get(i);
      if (bi) {
        for (const bii of bi.items) {
          ary.push(this.obj.bones[bii.index]);
        }
      } else {
        console.log('Missing bone: ', i, 'for set', n);
        return null;
      }
    }

    return ary;
  }
}

// #region DATA STRUCTURES
const BONE_SETS = {
  leftArm: ['upperarm_l', 'forearm_l', 'hand_l'],
  rightArm: ['upperarm_r', 'forearm_r', 'hand_r'],
  leftLeg: ['thigh_l', 'shin_l', 'foot_l'],
  rightLeg: ['thigh_r', 'shin_r', 'foot_r'],
  leftToe: ['toe_l'],
  rightToe: ['toe_r'],
  hip: ['hip'],
  spine: ['spine'],
  neck: ['neck'],
  head: ['head'],
};

export class BoneInfo {
  items = [];

  constructor(b = null) {
    if (b) this.push(b);
  }

  push(bone) {
    this.items.push({ index: bone.index, name: bone.name });
    return this;
  }

  get isChain() {
    return this.items.length > 1;
  }
  get count() {
    return this.items.length;
  }
  get index() {
    return this.items[0].index;
  }
  get lastIndex() {
    return this.items[this.items.length - 1].index;
  }
}
// #endregion

// #region NAME PARSING

class BoneParse {
  name = '';
  isLR = false;
  isChain = false;
  reFind = null;
  reExclude = null;
  allowSkip = true;

  constructor(
    name,
    isLR,
    reFind,
    reExclude,
    isChain = false,
    allowSkip = true,
  ) {
    this.name = name;
    this.isLR = isLR;
    this.isChain = isChain;
    this.reFind = new RegExp(reFind, 'i');
    this.allowSkip = allowSkip;
    if (reExclude) this.reExclude = new RegExp(reExclude, 'i');
  }

  test(bname) {
    if (!this.reFind.test(bname)) return null;
    if (this.reExclude && this.reExclude.test(bname)) return null;

    if (this.isLR && reLeft.test(bname)) return this.name + '_l';
    if (this.isLR && reRight.test(bname)) return this.name + '_r';

    return this.name;
  }
}

const reLeft = new RegExp('\\.l|left|_l', 'i');
const reRight = new RegExp('\\.r|right|_r', 'i');

const Parsers = [
  new BoneParse('thigh', true, 'thigh|up.*leg|hip(?!s)', 'twist'), //upleg | upperleg, hip NOT hips
  new BoneParse('shin', true, 'shin|leg|calf|knee', 'up|twist'),
  new BoneParse('foot', true, 'foot|ankle', null, false, false),
  new BoneParse('toe', true, 'toe|foot'),
  new BoneParse(
    'shoulder',
    true,
    'clavicle|shoulder|collar',
    null,
    false,
    false,
  ),
  new BoneParse(
    'upperarm',
    true,
    '(upper.*arm|arm|shoulder)',
    'fore|twist|lower',
  ),
  new BoneParse('forearm', true, 'forearm|arm|elbow', 'up|twist'),
  new BoneParse('hand', true, 'hand|wrist', 'thumb|index|middle|ring|pinky'),

  new BoneParse('head', false, 'head'),
  new BoneParse('neck', false, 'neck'),
  new BoneParse('hip', false, 'hips*|pelvis'),
  new BoneParse('root', false, 'root'),

  // eslint-disable-next-line no-useless-escape
  new BoneParse('spine', false, 'spine.*\d*|chest', undefined, true),
];

// #endregion
